/**
 * @generated SignedSource<<e05b78bed8800834cfed362fb297cde9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PaymentLinkTransactionDetails_pixQrCode$data = {
  readonly company: {
    readonly nameFriendly: string | null | undefined;
    readonly projectType: string | null | undefined;
    readonly taxID: {
      readonly taxID: string | null | undefined;
    } | null | undefined;
  } | null | undefined;
  readonly identifier: string | null | undefined;
  readonly " $fragmentType": "PaymentLinkTransactionDetails_pixQrCode";
};
export type PaymentLinkTransactionDetails_pixQrCode$key = {
  readonly " $data"?: PaymentLinkTransactionDetails_pixQrCode$data;
  readonly " $fragmentSpreads": FragmentRefs<"PaymentLinkTransactionDetails_pixQrCode">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PaymentLinkTransactionDetails_pixQrCode",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "identifier",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Company",
      "kind": "LinkedField",
      "name": "company",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "nameFriendly",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "projectType",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "TaxID",
          "kind": "LinkedField",
          "name": "taxID",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "taxID",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "PixQrCode",
  "abstractKey": null
};

(node as any).hash = "08c21f74e40f0e43f0a5c09b7f896c88";

export default node;
